import { createStore, compose, applyMiddleware, StoreEnhancer } from 'redux'
import rootReducer from './reducer/rootReducer';
import thunk from 'redux-thunk';
import { Env } from '../utils/constants';

const initialSate = {
}

export interface actionType {
    type: string,
    payload: any
}

declare global {
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
    }
}
const enhancers = [];

if (process.env.REACT_APP_ENV !== Env.Prod) {
    const devToolsExtension = window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__']
        || compose;
    if (typeof devToolsExtension === 'function') {
        enhancers.push(devToolsExtension())
    }
}

export const middlewares = [thunk];

const componsedEnhancer: StoreEnhancer = compose(applyMiddleware(...middlewares), ...enhancers)

const store = createStore(rootReducer, initialSate, componsedEnhancer);

export default store;